import { TextField, MenuItem, IconButton } from '@material-ui/core';
import React, { useEffect, useState } from 'react';

import { DragDropContext, Draggable, Droppable } from '@react-forked/dnd';
import { cloneDeep } from 'lodash';

import Constant from '@/common/constant/Constant';
import Utils from '@/common/utils/utils';
import { panelSettingAtom } from '@/state/atom/panelAtom';
import { useRecoilState } from 'recoil';
import { isUseItemInTicket, isEditField } from '../handler/CommonHandler';

import {
    getFormMasterList,
    getListItemOfRelatedField
} from '@/component/formManagement/addField/handler/AutoFilMasterFieldHandler';
import { getListFieldInForm } from '@/component/formManagement/addField/handler/AutoFilMasterFieldHandler';
import { fieldListOfProjectSelector, formListOfProjectSelector } from '@/state/selector/formSelector' ;
import OverFlowTooltipWithTabsMui from '@/component/common/OverFlowTooltipWithTabsMui';
import trI18n from '@/common/utils/trI18n';
import { tr, trLabel } from '@/common/utils/tr';
import { useTranslationSubscription } from '@/hooks/useTranslation';

export default function AutoFillMasterField(props) {
    // Subscribe to translation updates so displayed labels re-render on language change
    useTranslationSubscription();
    const [formMasterList, setFormMasterList] = useState([]);
    const [formMasterIdSelected, setFormMasterIdSelected] = useState(
        props.autoFillMasterField.formMaster
    );
    const [itemOfSelectedRelatedFieldList, setItemOfSelectedRelatedFieldList] = useState([]);
    const [itemActiveList, setItemActiveList] = useState([]);
    const [itemInActiveList, setItemInActiveList] = useState([]);
    const [settingSlideRecoilState, setSettingSlideRecoilState] = useRecoilState(panelSettingAtom);
    const [selectedRelatedField, setSelectedRelatedField] = useState(
        props.autoFillMasterField.relatedField
    );
    const [relatedFieldList, setRelatedFieldList] = useState([]);
    const [fieldListInState, setFieldListInState] = useRecoilState(fieldListOfProjectSelector);
    const [currentUpdateField] = useState(props.currentUpdateField);

    const [useButtonCollapse, setUseButtonCollapse] = useState(true);
    const [unUseButtonCollapse, setUnUseButtonCollapse] = useState(true);
    const [listFormOfProject, setListFormOfProject] = useRecoilState(formListOfProjectSelector);
    
    const argsCommon = {
        ...props,

        formMasterList,
        setFormMasterList,

        formMasterIdSelected,
        setFormMasterIdSelected,

        itemOfSelectedRelatedFieldList,
        setItemOfSelectedRelatedFieldList,

        itemActiveList,
        setItemActiveList,
        selectedRelatedField,
        setSelectedRelatedField,

        itemInActiveList: itemInActiveList,
        setItemInActiveList,

        settingSlideRecoilState,
        setSettingSlideRecoilState,
        relatedFieldList,
        setRelatedFieldList,
        listFormOfProject
    };

    // init data form master list
    useEffect(() => {
        // get form master list
        getFormMasterList(argsCommon);
    }, []);

    // get knowledge ticket list
    useEffect(() => {
        getListItemOfRelatedField(argsCommon);
    }, [
        formMasterIdSelected,
        formMasterList,
        selectedRelatedField,
        relatedFieldList,
        currentUpdateField
    ]);

    // update activeItemList
    useEffect(() => {
        let itemData = {
            itemActiveList: itemActiveList,
            itemInActiveList: itemInActiveList
        };
        updateAutoFillMasterField('active_list', itemData);
    }, [itemActiveList]);

    // update active item list/inactive item list
    useEffect(() => {
        if (currentUpdateField.relatedMasterForm !== formMasterIdSelected) {
            setItemActiveList([...itemOfSelectedRelatedFieldList]);
            setItemInActiveList([]);
        } else {
            let activeList = [];
            let inActiveList = [];

            itemOfSelectedRelatedFieldList.forEach(item => {
                if (item.isActive) {
                    activeList.push(item);
                } else {
                    inActiveList.push(item);
                }
            });

            setItemActiveList(activeList);
            setItemInActiveList(inActiveList);
        }
    }, [itemOfSelectedRelatedFieldList]);

    // update master knowledge
    const updateAutoFillMasterField = (type, data) => {
        let autoFillMasterFieldClone = cloneDeep(props.autoFillMasterField);
        switch (type) {
            case 'form_master':
                autoFillMasterFieldClone.formMaster = data;
                autoFillMasterFieldClone.errorFormMasterSelected = '';
                break;
            case 'auto_add_data':
                autoFillMasterFieldClone.isAutoAddData = !autoFillMasterFieldClone.isAutoAddData;
                break;
            case 'setting_auto_fill':
                autoFillMasterFieldClone.isAutoFill = !autoFillMasterFieldClone.isAutoFill;
                break;
            case 'active_list':
                let listItem = [];
                // active list
                data.itemActiveList.forEach((item, index) => {
                    let currentItem = props.masterKnowledge?.listItem?.find(
                        o => o.itemId === item.id
                    );
                    let hitNumber = Utils.isEmpty(currentItem) ? 0 : currentItem.hitNumber;
                    listItem.push({
                        itemId: item.id,
                        isActive: true,
                        hitNumber: hitNumber,
                        order: index,
                        listTicketId: item?.listTicketId ? item?.listTicketId : []
                    });
                });

                // inActive list
                data.itemInActiveList.forEach((item, index) => {
                    let currentItem = props.masterKnowledge?.listItem?.find(
                        o => o.itemId === item.id
                    );
                    let hitNumber = Utils.isEmpty(currentItem) ? 0 : currentItem.hitNumber;
                    listItem.push({
                        itemId: item.id,
                        isActive: false,
                        hitNumber: hitNumber,
                        order: index,
                        listTicketId: item?.listTicketId ? item?.listTicketId : []
                    });
                });
                autoFillMasterFieldClone.listItem = listItem;
                break;
            case 'related_field':
                autoFillMasterFieldClone.relatedField = data;
                autoFillMasterFieldClone.errorRelatedFieldSelected = '';
            default:
                break;
        }
        props.setAutoFillMasterField(autoFillMasterFieldClone);
    };

    // handler onChange form master
    const onChangeFormMaster = event => {
        let formId = event.target.value;
        setFormMasterIdSelected(formId);
        tagFieldOfMasterForm(formId);
        updateAutoFillMasterField('form_master', formId);
    };

    const onChangeField = event => {
        let fieldId = event.target.value;
        setSelectedRelatedField(fieldId);
        updateAutoFillMasterField('related_field', fieldId);
    };

    const tagFieldOfMasterForm = formId => {
        const formDetail = formMasterList.find(form => form.id === formId);

        const structure = Utils.convertJSONDataToObject(formDetail.structure);
        const listFieldOfForm = getListFieldInForm(structure, fieldListInState);
        const listTagField = listFieldOfForm.filter(
            field => field.type === Constant.FORM_TYPE.FIELD_TAG
        );
        setRelatedFieldList([...listTagField]);
    };

    /** handler onDragEnd */
    const onDragEnd = result => {
        // dropped outside the list
        if (!result.destination) {
            return;
        }

        let startIndex = result.source.index;
        let endIndex = result.destination.index;

        let itemActiveListClone = cloneDeep(itemActiveList);
        let [removed] = itemActiveListClone.splice(startIndex, 1);
        itemActiveListClone.splice(endIndex, 0, removed);

        //enable slide and set current start index
        let newSetting;
        newSetting = { ...settingSlideRecoilState };
        newSetting.disable = false;
        setSettingSlideRecoilState(newSetting);

        // update item active list
        // update item active list
        let itemData = {
            itemActiveList: itemActiveListClone,
            itemInActiveList: itemInActiveList
        };
        updateAutoFillMasterField('active_list', itemData);

        setItemActiveList(itemActiveListClone);
    };

    /** handler onBeforeDragStartHandler  */
    const onBeforeDragStartHandler = event => {
        //disable slide before drag start
        let newSetting = { ...settingSlideRecoilState };
        newSetting.disable = true;

        setSettingSlideRecoilState(newSetting);
    };

    /** handler onChangeUsingItem */
    const onChangeUsingItem = (event, field, isUsingItem) => {
        if (!isEditField(props.currentUpdateField, props)) {
            return;
        }

        let itemActiveListClone = cloneDeep(itemActiveList);
        let itemInActiveListClone = cloneDeep(itemInActiveList);

        if (!isUsingItem) {
            itemInActiveListClone.push(field);
            itemActiveListClone = Utils.removeItemInArrayById(field.id, itemActiveListClone);
        } else {
            itemActiveListClone.push(field);
            itemInActiveListClone = Utils.removeItemInArrayById(field.id, itemInActiveListClone);
        }

        setItemActiveList(itemActiveListClone);
        setItemInActiveList(itemInActiveListClone);
        let itemData = {
            itemActiveList: itemActiveListClone,
            itemInActiveList: itemInActiveListClone
        };
        // update item active list
        updateAutoFillMasterField('active_list', itemData);
    };

    const hanldeUseButtonCollapse = () => {
        if (useButtonCollapse === true) {
            setUseButtonCollapse(false);
        } else {
            setUseButtonCollapse(true);
        }
    };

    const hanldeUnUseButtonCollapse = () => {
        if (unUseButtonCollapse === true) {
            setUnUseButtonCollapse(false);
        } else {
            setUnUseButtonCollapse(true);
        }
    };

    /** render item */
    const renderItem = (field, index, activeItem) => {
        return (
            <>
                <div className="lst-number">{index + 1}.</div>
                <div className="lst-text">
                    <OverFlowTooltipWithTabsMui value={`${field.labelItem}`} />
                    <div className="item-formTag">
                        <>
                            <IconButton
                                className="itemTools"
                                onClick={event => onChangeUsingItem(event, field, false)}
                            >
                                <img src="/assets/image/icon-pin.svg" alt="" />
                            </IconButton>
                        </>
                    </div>
                </div>
            </>
        );
    };

    /** render item active list */
    const renderItemActiveList = () => {
        return (
            <DragDropContext onDragEnd={onDragEnd} onBeforeDragStart={onBeforeDragStartHandler}>
                <Droppable droppableId="droppable">
                    {(provided, snapshot) => (
                        <ul
                            {...provided.droppableProps}
                            ref={provided.innerRef}
                            // style={getListStyle(snapshot.isDraggingOver)}
                        >
                            {itemActiveList.map((item, index) => (
                                <Draggable
                                    // isDragDisabled={true}
                                    key={item.id}
                                    draggableId={`${item.id}`}
                                    index={index}
                                    isDragDisabled={
                                        props.displayOrder ===
                                        Constant.DISPLAY_ORDER_TAG_FIELD.HITS_NUMBER_ORDER
                                    }
                                >
                                    {(provided, snapshot) => (
                                        <li
                                            className={
                                                !isUseItemInTicket(item, props.currentUpdateField)
                                                    ? 'listField-li background-color-usingForm'
                                                    : 'listField-li'
                                            }
                                            id={item.id}
                                            key={item.id}
                                            ref={provided.innerRef}
                                            {...provided.draggableProps}
                                            {...provided.dragHandleProps}
                                            // style={getItemStyle(
                                            //     snapshot.isDragging,
                                            //     provided.draggableProps.style
                                            // )}
                                        >
                                            {renderItem(item, index, true)}
                                        </li>
                                    )}
                                </Draggable>
                            ))}
                            {provided.placeholder}
                        </ul>
                    )}
                </Droppable>
            </DragDropContext>
        );
    };

    /** render item inactive list */
    const renderItemInActiveList = () => {
        return (
            <ul>
                {itemInActiveList.map((item, index) => {
                    return (
                        <li
                            className={
                                !isUseItemInTicket(item, props.currentUpdateField)
                                    ? 'listField-li background-color-usingForm'
                                    : 'listField-li'
                            }
                        >
                            <>
                                <div className="lst-number">{index + 1}.</div>
                                <div className="lst-text">
                                    <OverFlowTooltipWithTabsMui value={item.labelItem} />
                                    <div className="item-formTag">
                                        <>
                                            <IconButton
                                                className="itemTools"
                                                onClick={event =>
                                                    onChangeUsingItem(event, item, true)
                                                }
                                            >
                                                <img
                                                    src="/assets/image/icon-pin-outline.svg"
                                                    alt=""
                                                />
                                            </IconButton>
                                        </>
                                    </div>
                                </div>
                            </>
                        </li>
                    );
                })}
            </ul>
        );
    };

    return (
        <>
            {Utils.isEmptyString(props.autoFillMasterField.formMaster) &&
                Utils.isEmptyArray(itemActiveList) &&
                Utils.isEmptyArray(itemInActiveList) && (
                    <div className="noChoices">
                        <span>
                            <img src="/assets/image/icon-listEmpty.svg" alt="" />
                        </span>
                        {trI18n('COMMSG034')}
                    </div>
                )}

            <div className="createCustomize">
                <ul>
                    <li>
                        <label className="createCustomize-label">{tr('使用するマスター')}</label>
                        <div className="createCustomize-control">
                            <TextField
                                SelectProps={{
                                    MenuProps: {
                                        anchorOrigin: {
                                            vertical: 'bottom',
                                            horizontal: 'left'
                                        },
                                        getContentAnchorEl: null,
                                        className: 'selectDrop'
                                    }
                                }}
                                disabled={!isEditField(props.currentUpdateField, props)}
                                className="form-control--wrap form-control--hg32"
                                value={formMasterIdSelected}
                                select
                                variant="outlined"
                                onChange={event => {
                                    onChangeFormMaster(event);
                                }}
                            >
                                {formMasterList.map((item, key) => {
                                    return (
                                        <MenuItem key={item.id} value={item.id}>
                                            {trLabel(Utils.getTextByLanguage(
                                                Constant.LANGUAGE_TYPE.JP,
                                                item.name
                                            ))}
                                        </MenuItem>
                                    );
                                })}
                            </TextField>

                            {!Utils.isEmptyString(
                                props.autoFillMasterField.errorFormMasterSelected
                            ) &&
                                formMasterList.length > 0 && (
                                    <>
                                        {' '}
                                        <br />
                                        <span className="message-error">
                                            {trI18n(
                                                `${props.autoFillMasterField.errorFormMasterSelected}`
                                            )}
                                        </span>
                                    </>
                                )}
                        </div>
                    </li>
                    <li>
                        <label className="createCustomize-label">{tr('使用するフィールド')}</label>
                        <div className="createCustomize-control">
                            <TextField
                                SelectProps={{
                                    MenuProps: {
                                        anchorOrigin: {
                                            vertical: 'bottom',
                                            horizontal: 'left'
                                        },
                                        getContentAnchorEl: null,
                                        className: 'selectDrop'
                                    }
                                }}
                                disabled={!isEditField(props.currentUpdateField, props)}
                                className="form-control--wrap form-control--hg32"
                                value={selectedRelatedField}
                                select
                                variant="outlined"
                                onChange={event => {
                                    onChangeField(event);
                                }}
                            >
                                {relatedFieldList.map((item, key) => {
                                    return (
                                        <MenuItem key={item.id} value={item.id}>
                                            {trLabel(Utils.getTextByLanguage(
                                                Constant.LANGUAGE_TYPE.JP,
                                                item.name
                                            ))}
                                        </MenuItem>
                                    );
                                })}
                            </TextField>

                            {!Utils.isEmptyString(
                                props.autoFillMasterField.errorRelatedFieldSelected
                            ) &&
                                relatedFieldList.length > 0 && (
                                    <>
                                        {' '}
                                        <br />
                                        <span className="message-error">
                                            {trI18n(
                                                `${props.autoFillMasterField.errorRelatedFieldSelected}`
                                            )}
                                        </span>
                                    </>
                                )}
                        </div>
                    </li>
                </ul>
            </div>

            <div className="createSwitch">
                <p className="createSwitch-text">{tr('新しいマスターナレッジを選択項目に自動追加する')}</p>
                <div className="switch-check">
                    <input
                        type="checkbox"
                        id={`switch-show-all-chat-post-auto_add_data_with_outline_ticket`}
                        defaultChecked={props.autoFillMasterField.isAutoAddData}
                        onChange={event => {
                            updateAutoFillMasterField('auto_add_data');
                        }}
                        disabled={!isEditField(props.currentUpdateField, props)}
                    />
                    <label
                        for={`switch-show-all-chat-post-auto_add_data_with_outline_ticket`}
                    ></label>
                </div>
            </div>

            <div className="createSwitch">
                <p className="createSwitch-text">{tr('フィールドを連動する')}</p>
                <div className="switch-check">
                    <input
                        type="checkbox"
                        id={`switch-show-all-chat-post-setting_auto_fill_with_outline_ticket`}
                        defaultChecked={props.autoFillMasterField.isAutoAddData}
                        onChange={event => {
                            updateAutoFillMasterField('setting_auto_fill');
                        }}
                        disabled={!isEditField(props.currentUpdateField, props)}
                    />
                    <label
                        for={`switch-show-all-chat-post-setting_auto_fill_with_outline_ticket`}
                    ></label>
                </div>
            </div>

            <ul className="listForm-ul master-knowledge-listItem">
                {!Utils.isEmptyString(props.autoFillMasterField.formMaster) &&
                    Utils.isEmptyArray(itemActiveList) &&
                    Utils.isEmptyArray(itemInActiveList) && (
                        <div className="master-knowledge-item-empty">{trI18n('COMMSG034')}</div>
                    )}

                {(!Utils.isEmptyArray(itemActiveList) || !Utils.isEmptyArray(itemInActiveList)) && (
                    <>
                        <div
                            className={
                                !useButtonCollapse
                                    ? 'accordionForm accordionForm--show'
                                    : 'accordionForm'
                            }
                        >
                            {/* Khi click vào 'div accordionHead' thì 'div accordionForm sẽ add accordionForm--show' */}
                            <div className="accordionHead" onClick={hanldeUseButtonCollapse}>
                                <span className="accordionHead-item">
                                    <img src="/assets/image/icon-pin.svg" alt="" />
                                </span>
                                <span className="accordionHead-text">
                                    {tr('以下の選択項目は使用する')} ({itemActiveList.length})
                                </span>
                            </div>
                            <div className="accordionContent">
                                <div className="lst-formTag">{renderItemActiveList()}</div>
                                {/* lst-formTag */}
                            </div>
                        </div>
                        {/* accordionForm */}
                        <div
                            className={
                                !unUseButtonCollapse
                                    ? 'accordionForm accordionForm--show'
                                    : 'accordionForm'
                            }
                        >
                            {/* Khi click vào 'div accordionHead' thì 'div accordionForm sẽ add accordionForm--show' */}
                            <div className="accordionHead" onClick={hanldeUnUseButtonCollapse}>
                                <span className="accordionHead-item">
                                    <img src="/assets/image/icon-pin-outline.svg" alt="" />
                                </span>
                                <span className="accordionHead-text">
                                    {tr('以下の選択項目は使用しない')} ({itemInActiveList.length})
                                </span>
                            </div>
                            <div className="accordionContent">
                                <div className="lst-formTag">{renderItemInActiveList()}</div>
                                {/* lst-formTag */}
                            </div>
                        </div>
                    </>
                )}
            </ul>
        </>
    );
}
